import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Ir para o conteúdo principal
      </a>
      <Header />
      <main id="main-content" className="container" style={{ paddingTop: "var(--space-7)", paddingBottom: "var(--space-8)", minHeight: "60vh" }}>
        {children}
      </main>
      <Footer />
    </>
  );
}
